import { ComponentProps } from 'react';

import { EyeSvg } from 'components/svgs/EyeSvg/EyeSvg';

import { EditButton } from './EditButton';

interface ApiEditButtonProps extends ComponentProps<typeof EditButton> {
  hasWritePermission: boolean;
}

export const ApiEditButton = ({
  hasWritePermission,
  ...editButtonProps
}: ApiEditButtonProps) => {
  return (
    <EditButton
      {...(!hasWritePermission && { icon: <EyeSvg /> })}
      {...editButtonProps}
    />
  );
};
